"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var payment_history_iterator_1 = require("./payment-history-iterator");
var PaymentHistoryStoreNullObject = /** @class */ (function () {
    function PaymentHistoryStoreNullObject() {
    }
    PaymentHistoryStoreNullObject.prototype.get = function (blockchainId, accountId, start, pageSize) {
        return [];
    };
    PaymentHistoryStoreNullObject.prototype.getCount = function (blockchainId, accountId) {
        return 0;
    };
    PaymentHistoryStoreNullObject.prototype.getIterator = function (blockchainId, accountId, pageSize) {
        return new payment_history_iterator_1.default(this, blockchainId, accountId, pageSize);
    };
    PaymentHistoryStoreNullObject.prototype.getSyncInfo = function (blockchainId, accountId) {
        return {};
    };
    PaymentHistoryStoreNullObject.prototype.save = function (blockchainId, accountId, paymentHistoryEntries) {
    };
    PaymentHistoryStoreNullObject.prototype.saveSyncInfo = function (blockchainId, accountId, syncInfo) {
    };
    PaymentHistoryStoreNullObject.prototype.deletePaymentHistory = function (accountId, blockchainId) {
    };
    return PaymentHistoryStoreNullObject;
}());
exports.default = PaymentHistoryStoreNullObject;
//# sourceMappingURL=payment-history-store-null-object.js.map